import { useEffect, useRef, useState } from "react";
import { Formik, Form } from "formik";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { SelectField } from "../../../core/select-field.component";
import { useGetZones } from "../../../apiclient/master/useGetZoneApi";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { useGetDroppingPoint } from "../../../apiclient/party/useGetDropingPointApi";
import { formatDate } from "@progress/kendo-intl";
import axios from "axios";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { API_END_POINT } from "../../../constants";
import { getDataWithToken, getEndPoint } from "../../../Utils/network.client";
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useGetCompanyDetails } from "../../../apiclient/master/useGetCompanydetailsApi";


export const DailyCounterSaleReport: React.FC = () => {
  const [zoneData, setZoneData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedZone } = useGetZones();
  const [droppingPointData, setDroppingPointData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedDroppingPoint } = useGetDroppingPoint();
  const excelExport = useRef<ExcelExport | null>(null);
  const pdfExportRef = useRef<PDFExport | null>(null);

  const [selectedZoneName, setSelectedZoneName] = useState("");
const [selectedDroppingPointName, setSelectedDroppingPointName] = useState("");

  const { data: companyDetails, isLoading: isCompanyLoading } =
  useGetCompanyDetails();
const companyName = companyDetails?.[0]?.companyName || "Company Name";

  const customerTypes = [
    { value: "booth", label: "Booth" },
    { value: "customer", label: "Customer" }
  ];

  const [customerType, setCustomerType] = useState(1);  

  const exportExcel = () => {
    if (!excelExport.current) return;

    const options = excelExport.current.workbookOptions();
    const sheet = options.sheets[0];

    const formattedDate = fromDate1
      ? new Date(fromDate1).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
      : "";

      const headingWithDate =
     `Daily Counter Sale Report - ${formattedDate}` +
      (zoneData ? ` - ${zoneData}` : "") +
      (droppingPointData ? ` - ${droppingPointData}` : "");

    // Add a single merged heading row with the full string
    sheet.rows.unshift({
      cells: [
        {
          value: headingWithDate,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });
    sheet.rows.unshift({
      cells: [
        {
          value: companyName,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });

    excelExport.current.save(options);
  };

  const exportToPDF = () => {
    if (pdfExportRef.current) {
      pdfExportRef.current.save();
    }
  };

  useEffect(() => {
    if (fetchedZone) {
      const mappedZone = fetchedZone.map((zone: any) => ({
        value: zone.zoneId,
        label: zone.name,
      }));
      setZoneData(mappedZone);
    }

    if (fetchedDroppingPoint) {
      const mappedDroppingPoint = fetchedDroppingPoint.map(
        (droppingPoint: any) => ({
          value: droppingPoint.droppingpointId,
          label: droppingPoint.name,
        })
      );
      setDroppingPointData(mappedDroppingPoint);
    }
  }, [fetchedZone, fetchedDroppingPoint]);

  const [fromDate1, setFromDate] = useState<Date>(
    new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
  );

  const [fromDate2, setFromDate2] = useState<string>(
    ""
  );

  const [gridData, setGridData] = useState([]);
  const [columns, setColumns] = useState([]);


  const initialValues = {
    zoneId: "",
    fromDate: fromDate1,
    droppingpointId: "",
  };


  const [zoneid, setZoneId] = useState([]);
  const [droppingpointid, setDropingpointId] = useState([]);


  const handlecountersales = async () => {
    try {

      setGridData([]);

      const apiUrl = `${getEndPoint(API_END_POINT.REPORT)}/api/OrderCollectionReports/GetDailyCounterSaleReport/${zoneid}/${fromDate2}/${customerType}`;
      // const apiUrl = "https://localhost:44314/api/OrderCollectionReports/GetDailyCounterSaleReport/1/2024-10-01/0";

       const response = await getDataWithToken<any>(
                                 apiUrl 
                                          );

      // const response = await axios.get(apiUrl);

      if (response.data.jsonstring) {

        const parsedData = JSON.parse(response.data.jsonstring);

        const columnHeaders: string[] = Object.values(parsedData.header[0]) as string[];
        const updatedColumns = ["SNo", ...columnHeaders];
        setColumns(updatedColumns);


        if (parsedData.details != null) {
          const transformedData = parsedData.details.map((row: Record<string, any>, index: number) => {
            let newRow: Record<string, any> = { "SNo": index + 1 };
            Object.keys(row).forEach((key, index) => {
              newRow[columnHeaders[index]] = row[key]; // Now TypeScript knows columnHeaders[index] is a string
            });
            return newRow;
          });

          // Calculate totals for numeric columns
          const subtotalRow: Record<string, any> = {};
          columnHeaders.forEach((col) => {
            const total = transformedData.reduce((sum: number, row: { [x: string]: string; }) => {
              const value = parseFloat(row[col]);
              return !isNaN(value) ? sum + value : sum;
            }, 0);
            subtotalRow[col] = isNaN(total) || col == "CATEGORY" || col == "BOOTH" || col == "AGENT" ? "" : total.toFixed(2);
            // Empty for non-numeric columns
          });

          // Append subtotal row to data
          transformedData.push({ ...subtotalRow, zone: "Total" }); // Add label for subtotal row
          setGridData(transformedData);

          console.log("Columns:", columns);
          console.log("Grid Data:", gridData);
        } else {
          console.error("No Records");
        }

      } else {
        console.error("Invalid response format");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Re-throwing in case you need to handle it outside
    }
  };

  const handleZoneChange = (value: any) => {
    setZoneId(value);
    const selected = zoneData.find((z) => z.value === value);
    setSelectedZoneName(selected?.label || "");
    console.log("zone id is:", value);
  };
  
  const handleDroppingPointChange = (value: any) => {
    setDropingpointId(value);
    const selected = droppingPointData.find((d) => d.value === value);
    setSelectedDroppingPointName(selected?.label || "");
    console.log("dropping point id is:", value);
  };

  const handleCustomerChange = (value: any) => {
    if (value == "Customer")
    {setCustomerType(0);}
    else{setCustomerType(1);}
      };

  const handleDateChange = (value: any) => {
    // const today = new Date();
    const day = value.getDate().toString().padStart(2, '0');
    const month = value.toLocaleString('default', { month: 'short' }).toUpperCase(); // Get short month (e.g., JAN)
    const year = value.getFullYear();

    const formattedDate = new Date(`${year}-${month}-${day}`);

    setFromDate(formattedDate);

    // const formattedDate2 = dayjs(value).format('ddd MMM DD YYYY HH:mm:ss');
    // console.log(formattedDate2);
    // setFromDate2(formattedDate2);
  };

  useEffect(() => {
    if (fromDate1) {
      const formattedDate2 = dayjs(fromDate1).format('ddd MMM DD YYYY HH:mm:ss');
      console.log("Formatted Date:", formattedDate2);
      setFromDate2(formattedDate2);
    }
  }, [fromDate1]);
  const hasRecords = gridData.length > 0; 

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        console.log("Form submitted with values: ", values);
      }}
    >
      {({ setFieldValue, values }) => (
        <Form>
          <div
            className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15"
            style={{ minHeight: "500px" }}
          >
            <div className="top-sec-align row">
              <center>
                <h4 className="text-normal title-web mb-0 report-title-color">
                  Daily Counter Sale Report
                </h4>
              </center>
            </div>
            <div className="fade_rule"></div>
            <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
              {/* <div>
                <label>Search</label>
                <input
                  type="text"
                  className="form-control ms-auto search-right-align searchBg"
                />
              </div> */}

              <div className="d-flex">
                <div className="me-2">
                  <label>Select Counter </label>
                  <SelectField
                    //  label="Zone"
                    name="zoneId"
                    options={zoneData}
                    unSelectValue={0}
                    notifyChange={handleZoneChange}

                  />
                </div>
                <div className="me-2">
                  <label> Select Date</label>
                  <DatePicker
                    selectsMultiple={true}
                    openToDate={new Date()}
                    className="form-control ms-auto search-right-align calendarBg"
                    value={formatDate(fromDate1, "dd/MM/yyyy")}
                    placeholderText="To"
                    dateFormat={"dd/MM/yyyy"}
                    onChange={([date]: any) => {
                       setFromDate(date);
                      handleDateChange(date)
                    }}
                  />
                </div>
                <div className="me-2">
                  <label>Select Type Of User </label>
                  <SelectField
                    name="customerType"
                    options={customerTypes}
                    unSelectValue=""
                    notifyChange={(value: any) => handleCustomerChange(value)}
                  />
                </div>
                <div>
                  <label></label>
                  <button
                    className="btn-primary btn search-btns mt-4"
                    type="submit"
                    onClick={() => {
                      handlecountersales()
                    }}
                  >
                    <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                      <path
                        id="Path_magnify"
                        data-name="Path / magnify"
                        d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                        transform="translate(-3 -3)"
                        fill="#fff"
                      />
                    </svg>
                  </button>
                </div>
                <div className="d-flex justify-content-end">
                <button
                title="Export Excel"
                className="export-button ms-2"
                onClick={exportExcel}
                  disabled={!hasRecords}
                style={{ marginTop: "23px",marginBottom: "17px"  }}
              >
                Export to Excel
              </button>
              <button
                title="Export Excel"
                className="export-button ms-2"
                onClick={exportToPDF}
                  disabled={!hasRecords}
                style={{ marginTop: "23px",marginBottom: "17px"  }}
              >
                Export to PDF
              </button>

                </div>
              </div>
            </div>
            {/* <div className="row col=12"> */}
            <div>
            <PDFExport 
              ref={pdfExportRef} 
              fileName="Route_Summary_Report.pdf"
              title="Route Summary"
>
              
              <div style={{ padding: "10px", backgroundColor: "#fff" }}>
                  {/* Company Name */}
                  <div style={{ textAlign: "center", marginBottom: "5px" }}>
                    <span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                      {companyDetails?.[0]?.companyName || "Company Name"}
                    </span>
                  </div>
                  <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    <span style={{ fontWeight: "bold", fontSize: "1.25rem" }}>
                    Daily Counter Sale
                      {fromDate1 && (
                        <>
                          {" - "}
                          {new Date(fromDate1).toLocaleDateString("en-IN", {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                          })}
                        </>
                      )}
                      {/* {selectedSessionName && ` - ${selectedSessionName}`} */}
                    </span>
                  </div>
                  
                  {gridData.length > 0 && columns.length > 0 ? (
                    // <Grid data={gridData} style={{ height: "auto" }}>
                    //   {columns.map((col, index) => (
                    //     <GridColumn key={index} field={col} title={col}  className={index > 2 ? "text-end" : ""} />
                    //   ))}
                    // </Grid>
                    <Grid data={gridData} style={{ height: "auto" }} resizable>
                      <GridColumn field="SNo" title="S.No" width="70px" className={"text-center"} />
                      <GridColumn field="BOOTH" title="BOOTH" width="70px" />
                      <GridColumn field="AGENT" title="AGENT" width="240px" />  {/* Increase width */}
                      {columns
                        .filter((col) => col !== "SNo" && col !== "AGENT" && col !== "BOOTH") // Exclude SNo & AGENT (already added)
                        .map((col, index) => (
                          <GridColumn key={index} field={col} title={col} width="95px" className={"text-end"} />
                        ))}
                    </Grid>
                  ) : (
                    <p>No data available</p>
                  )}
                </div>
              </PDFExport>

              <ExcelExport data={gridData} ref={excelExport} fileName="Daily_Counter_Sale_Report.xlsx">
                {columns.map((col, index) => (
                  <ExcelExportColumn key={index} field={col} title={col} />
                ))}
              </ExcelExport>

              {/* {gridData.length > 0 && columns.length > 0 ? (
                <Grid data={[...gridData]} style={{ height: "400px" }}>
                  {columns.map((col, index) => (
                    <GridColumn
                      key={index}
                      field={col}
                      title={col}
                      className={index > 2 ? "text-end" : ""}
                      headerClassName={index > 2 ? "text-end" : ""}
                    // footerCell={() => {
                    //   const total = columnTotals(col);
                    //   return !isNaN(total) ? <strong>{total.toFixed(2)}</strong> : null;
                    // }}                
                    />
                  ))}
                </Grid>
              ) : null} */}

            </div>
            {/* </div> */}
          </div>
        </Form>
      )}
    </Formik>
  );
};
